export const buildApprovalStepRuleLabel = (rule: string) => {
    return `lomavisApproval.stepRule.${rule}`; // i18n key
}